import { render, staticRenderFns } from "./MaterialPractice1.vue?vue&type=template&id=282430ba&"
import script from "./MaterialPractice1.vue?vue&type=script&lang=ts&"
export * from "./MaterialPractice1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports